import React from "react";
import "./activeDep.css";

const ActiveDep = () => {
  return (
    <>
      <div className="activeDepPage">
        <div class="plan-table">
          <table>
            <thead>
              <tr>
                <th>Plan</th>
                <th>Deposit Amount</th>
                <th>Profit (%)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>BASIC</td>
                <td>$100 - Unlimited</td>
                <td>10.00</td>
              </tr>
            </tbody>
          </table>
          <p class="no-deposit-message">No deposits for this plan</p>
        </div>
        <div class="plan-table">
          <table>
            <thead>
              <tr>
                <th>Plan</th>
                <th>Deposit Amount</th>
                <th>Profit (%)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>SILVER</td>
                <td>$1000 - Unlimited</td>
                <td>15.00</td>
              </tr>
            </tbody>
          </table>
          <p class="no-deposit-message">No deposits for this plan</p>
        </div>
        <div class="plan-table">
          <table>
            <thead>
              <tr>
                <th>Plan</th>
                <th>Deposit Amount</th>
                <th>Profit (%)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>GOLD</td>
                <td>$5,000 - Unlimited</td>
                <td>20.00</td>
              </tr>
            </tbody>
          </table>
          <p class="no-deposit-message">No deposits for this plan</p>
        </div>
        <div class="plan-table">
          <table>
            <thead>
              <tr>
                <th>Plan</th>
                <th>Deposit Amount</th>
                <th>Profit (%)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>PLATINUM</td>
                <td>$10,000- Unlimited</td>
                <td>30.00</td>
              </tr>
            </tbody>
          </table>
          <p class="no-deposit-message">No deposits for this plan</p>
        </div>
      </div>
    </>
  );
};

export default ActiveDep;
